import React from 'react';
import { Link } from 'react-router-dom';
import ChatBubbleIcon from '@material-ui/icons/ChatBubble';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddCultureButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="raised"
    component={Link}
    to={`/cultures/create?id_sample=${record.id}`}
    label="Add a culture"
    title="Add a culture"
  >
    <ChatBubbleIcon />
  </Button>
);

export default withStyles(styles)(AddCultureButton);
